import { render } from "./App.vue?vue&type=template&id=47ff5acc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=47ff5acc&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=47ff5acc&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ff5acc"]])

export default __exports__